import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMsg('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9q2fs7nahb7382ov52g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse error */ }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后重试';
        if (typeof msg === 'string' && (msg.toLowerCase().includes('spam') || msg.includes('spam'))) {
          setErrorMsg('订阅失败，请稍后重试');
        } else {
          setErrorMsg(typeof msg === 'string' ? msg : '订阅失败，请稍后重试');
        }
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅asmr1 Newsletter
        </h2>
        <p className="text-background-400 mb-8 leading-relaxed">
          第一时间获取最新ASMR内容更新、精选推荐和独家音频资源。每周一封，绝不打扰。
        </p>

        {status === 'success' ? (
          <div className="bg-accent-100/20 text-accent-300 rounded-xl p-5">
            <p className="font-medium">订阅成功！感谢你的关注。</p>
            <p className="text-sm mt-1 text-accent-400">我们会将最新的ASMR内容发送到你的邮箱。</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form="true" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full bg-background-800 text-background-100 placeholder:text-background-500 border border-background-700 focus:outline-none focus:border-accent-500 transition-colors duration-200 text-sm"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors duration-200 disabled:opacity-60 whitespace-nowrap"
            >
              {status === 'loading' ? '订阅中...' : '立即订阅'}
            </button>
          </form>
        )}
        {status === 'error' && errorMsg && (
          <p className="mt-3 text-sm text-red-400">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}